import { createContext, useState, useEffect, useContext } from 'react';

export const AuthContext = createContext({});

const AuthContextProvider = ({ children }) => {
  const [isLoggedin, setIsLoggedin] = useState(false);
  const [userInfo, setUserInfo] = useState({});

  useEffect(() => {
    const user = {
      token: sessionStorage.getItem('11#221#') || '',
      tenantCode: sessionStorage.getItem('tenantCode') || '',
      userId: sessionStorage.getItem('userId') || '',
      tenantPhone: sessionStorage.getItem('tenantPhone'),
    };
    setUserInfo(user);
  }, []);

  return <AuthContext.Provider value={{ isLoggedin, setIsLoggedin, userInfo }}>{children}</AuthContext.Provider>;
};

export default AuthContextProvider;

export const useAuth = () => {
  return useContext(AuthContext);
};
